<form [formGroup]="form" class="form">
  <kt-form-tab-header [headers]="formTabHeaders$|async" (tabChange)="onTabChange($event)"></kt-form-tab-header>

  <mat-tab-group class="invinsible-tabs" [selectedIndex]="selectedTab">
    <mat-tab>
      <div class="card-body pt-0 mat-container">
        <kt-map-location title="Location" parentType="comparable" [showMap]="true" [lockMarker]="false"
          [isSavedBefore]="isSavedBefore" [locationData]="locationData$|async" [isComplexForm]="isComplexForm$|async"
          [centerLat]="centerLat" [centerLng]="centerLng"
          (formStateChange)="onMapLocationFormChange($event)"
          (markerChange)="onMarkerChange($event)"></kt-map-location>

        <app-parcel-identification *ngIf="isComplexForm$|async" class="section-margin-top-60"
          [form]="form.controls.parcel_identification" [centerLat]="centerLat" [centerLng]="centerLng"
          [coordinatePoints]="coordinatePoints$|async" [landAreas]="landAreas$|async"
          [marker]="markerInfo$|async"
          (coordinatePointsChange)="onCoordinatePointsChange($event)"
          (landAreasChange)="onLandAreasChange($event)"></app-parcel-identification>
      </div>
    </mat-tab>

    <mat-tab>
      <div class="card-body pt-0 mad-container">
        <div class="form-group row section-margin-top-60">
          <div class="col-lg-12">
            <h5 class="my-3 text-mad text-uppercase">About the property</h5>
            <hr class="active" />
          </div>

          <div class="col-lg-4">
            <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.property_type_id">
              <mat-select placeholder="Special purpose Type" formControlName="property_type_id">
                <mat-option *ngFor="let item of (purposeTypes$|async)" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
              <mat-hint [formFieldHintState]="form.controls.property_type_id">
                Special purpose type <span>required</span>
              </mat-hint>
              <mat-error>
                Special purpose type <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4">
            <mat-form-field class="mat-form-field-fluid">
              <input matInput placeholder="Completion Year" formControlName="completion_year" />
            </mat-form-field>
          </div>

          <div class="col-lg-4">
            <mat-form-field class="mat-form-field-fluid">
              <input matInput placeholder="Building ID" formControlName="building_name" />
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <mat-select placeholder="Property grade" formControlName="property_grade_id">
                <mat-option *ngFor="let item of grades" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <input matInput type="text" mask="0000" [validation]="false" placeholder="Number of floors (above ground)"
                formControlName="above_floors" />
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <input matInput type="text" mask="0000" [validation]="false" placeholder="Basement floors"
                formControlName="below_floors" />
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <mat-select placeholder="Handover standard" formControlName="handover_standard_id">
                <mat-option *ngFor="let item of handoverStandards" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <mat-select placeholder="State of repair" formControlName="state_of_repair_id">
                <mat-option *ngFor="let item of stateOfRepairs" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <mat-select placeholder="Foundation type" formControlName="foundation_type_id">
                <mat-option *ngFor="let item of foundationTypes" [value]="item.id">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-4" *ngIf="isComplexForm$|async">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Developer" formControlName="developer" >
              </mat-form-field>
          </div>

          <div class="col-lg-4" *ngIf="isComplexForm$|async">
              <mat-form-field class="mat-form-field-fluid">
                  <input matInput placeholder="Primary anchor tenant" formControlName="anchor_tenant"> 
              </mat-form-field>
          </div>

          <div class="col-lg-4">
            <div class="row">
              <span class="col-12 font-weight-bold">Ancillary Buildings</span>
              <div class="col-12 mt-2">
              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  <mat-radio-group formControlName="has_ancillary_buildings">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                  </mat-radio-group>
                </div>

                <div class="col-lg-6 kt-margin-bottom-20-mobile" *ngIf="form.controls.has_ancillary_buildings.value">
                  <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.ancillary_buildings_num">
                    <input matInput type="text" mask="0000" [validation]="false" placeholder="Ancillary Buildings Number"
                      formControlName="ancillary_buildings_num" />

                    <mat-hint [formFieldHintState]="form.controls.ancillary_buildings_num">
                      Number <span>required</span>
                    </mat-hint>
                    <mat-error>
                      Number <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              </div>
            </div>
          </div>



          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <textarea matInput rows="3" placeholder="Construction description"
                formControlName="construction_desc"></textarea>
            </mat-form-field>
          </div>

          <div class="col-lg-12 mt-10" *ngIf="isComplexForm$|async">
              <kt-accommodation-layout-table
                  [propertySubTypeID]="18"
                  [specialPurposeTypeID]="form.controls.property_type_id.value"
                  [aboveFloor]="aboveFloor$"
                  [belowFloor]="belowFloor$"
                  [floors$]="floors$"
                  [initData]="accomodationData$|async"
                  [initOthers]="accomodationOthers$|async"></kt-accommodation-layout-table>
          </div>
        </div>

        <ng-container *ngIf="serviceAndInfraData$|async as vm">
          <ng-container *ngIf="vm">
            <div class="form-group kt-form__group row section-margin-top-60">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <h5 class="my-3 text-mad text-uppercase">
                  Services and Infrastructures
                </h5>
                <hr class="active">
              </div>
              <div class="col-lg-12">
                <kt-services-and-infrastructures [isComplexForm]="isComplexForm$|async"
                  [serviceAndInfraData]="vm">
                </kt-services-and-infrastructures>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm$|async">
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <h5 class="my-3 text-mad text-uppercase">
              {{externalAspectSectionTitle$ | async}}
            </h5>
            <hr class="active">
          </div>
          <div class="col-lg-12">
            <kt-external-aspects [propertySubTypeID]="18" [formType]="'comparable'"
              [externalAspectData]="externalAspectData$|async"></kt-external-aspects>
          </div>
        </div>

        <div class="form-group kt-form__group row section-margin-top-60" *ngIf="isComplexForm$|async">
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <h5 class="my-3 text-mad text-uppercase">
              {{internalAspectSectionTitle$ | async}}
            </h5>
            <hr class="active">
          </div>
          <div class="col-lg-12">
            <kt-internal-aspects [propertySubTypeID]="18" [formType]="'comparable'"
              [internalAspectData]="internalAspectData$|async"></kt-internal-aspects>
          </div>
        </div>

        <div class="form-group kt-form__group row section-margin-top-60">
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <h5 class="my-3 text-mad text-uppercase">
              {{ groundsSectionTitle$|async }}
            </h5>
            <hr class="active">
          </div>
          <div class="col-lg-12">
            <kt-ac-grounds [isComplexForm]="isComplexForm$|async" [propertySubTypeID]="18"
              [initData]="groundsData$|async">
            </kt-ac-grounds>
          </div>
        </div>

        <kt-ac-size class="section-margin-top-60" [title]="sizesSectionTitle$|async" [sizesSubject]="sizesSubject"
          [assetClassType]="'18'"></kt-ac-size>
        <mat-error 
            errorStateWithLength
            [hasFormError]="hasFormErrors"
            [isInValid]="sizesSubject.value.length === 0"
            [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
            }"
        >
        </mat-error>

        <ng-container *ngIf="numberOfBuildings$|async">
          <div class="form-group kt-form__group row section-margin-top-60">
            <div class="col-lg-12 kt-margin-bottom-20-mobile">
              <h5 class="my-3 text-mad text-uppercase">
                Ancillary Buildings
              </h5>
              <hr class="active">
            </div>

            <div class="col-lg-12">
              <mat-tab-group>
                <ng-container *ngFor="let building of (buildings$|async); let i = index; trackBy: identity">
                  <mat-tab>
                    <ng-template mat-tab-label>
                      {{ i + 1}} - Building {{ i + 1}}
                    </ng-template>
                    <app-ancillary-building-form
                      [building]="building"
                      [mainWallOptions]="mainwalls"
                      [externalFacadeOptions]="externalFacades"
                      [roofCoveringOptions]="roofCoverings"
                      [unitAreaMeasurementOptions]="unitAreaMeasurements"
                      (buildingChange)="onBuildingChange($event)"
                    ></app-ancillary-building-form>
                  </mat-tab>
                </ng-container>
              </mat-tab-group>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>
    <mat-tab>
      <kt-esg-indicators formType="comparable" [value]="esgIndicatorData$|async"
        [systemOfMeasurement]="userUnitOfMeasurementId$|async" />
    </mat-tab>

    <mat-tab>
      <div class="card-body pt-0 mad-container">
        <kt-consideration-and-source style="margin-top: 60px;" [inputConsiderations]="tenuresSubject|async"
          [landAreaComponentListSubject]="comps" [hasParcelInfo$]="hasParcel" [timezoneOffset]="timezoneOffset"
          [sizes]="sizes$|async" (considerationsChange)="onConsiderationsChange($event)"></kt-consideration-and-source>
        <mat-error errorStateWithLength [hasFormError]="hasFormErrors" [isInValid]="considerationError$|async">
          Input <strong>required</strong>
        </mat-error>
      </div>
    </mat-tab>

    <mat-tab>
      <div class="card-body pt-0 mad-container">
        <div class="form-group row section-margin-top-60">
          <div class="col-lg-12">
            <h5 class="my-3 text-mad text-uppercase">
              Property Pictures
            </h5>
            <hr class="active">
          </div>

          <kt-upload-file #simple class="col-lg-12" [filesOnEditMode]="acPictures$|async"
            [folderOnEditMode]="picture$|async" [readOnly]="false" [parentForm]="'land'" [typeField]="false"
            fileType="image/*" split="1" [featuredPictureAllowed]="true" [hasThumbnail]="true"
            [addButtonLabel]="'Add Picture'">
          </kt-upload-file>
          <div class="col-md-12 kt-margin-bottom-20-mobile">
            <mat-error class="interval-error" *ngIf="hasFormErrors && showTitleRequiredError$|async">
              Picture should have a <strong>Title</strong>
            </mat-error>
          </div>
        </div>

        <kt-ac-document-upload *ngIf="isComplexForm$|async" class="section-margin-top-60" [files]="documents$|async">
        </kt-ac-document-upload>
      </div>
    </mat-tab>
  </mat-tab-group>
</form>